import React, { createContext, useState, useEffect, useContext } from 'react';
import { useParams } from 'react-router-dom';
import UserContext from './UserContext';
import { API_URLS } from './config';

const defaultBranding = {
    logoUrl: '/app/images/logo.png',
    headerUrl: '/app/images/front-page-image.png',
    accentColor: '#007BFF', // Default accent color
    fontStyle: 'Arial',
    isLoading: true,
};

export const BrandingContext = createContext(defaultBranding);

export const BrandingProvider = ({ children }) => {
    const [branding, setBranding] = useState(defaultBranding);
    const { token } = useContext(UserContext);
    const { id } = useParams(); // Get id here as it's needed for fetching

    useEffect(() => {
        if (!token || !id) {
            // If no token or id, keep default branding but set loading to false
            setBranding(prev => ({ ...prev, isLoading: false }));
            return;
        }

        setBranding(prev => ({ ...prev, isLoading: true })); // Set loading true before fetch

        fetch(API_URLS.branding(id), {
            headers: { 'Authorization': `Bearer ${token}` }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            console.log("Branding data fetched:", data); // Debugging line
            if (data && data.length > 0) {
                const fetchedBranding = data[0];
                setBranding({
                    logoUrl: fetchedBranding.logo_image_link || defaultBranding.logoUrl,
                    headerUrl: fetchedBranding.header_image_link || defaultBranding.headerUrl,
                    accentColor: fetchedBranding.accent_color || defaultBranding.accentColor,
                    fontStyle: fetchedBranding.font_style || defaultBranding.fontStyle,
                    isLoading: false,
                });
            } else {
                // No specific branding found, use defaults
                console.log("No branding data found, using defaults");
                setBranding({ ...defaultBranding, isLoading: false });
            }
        })
        .catch(error => {
            console.error("Error fetching branding:", error);
            // On error, use defaults
            setBranding({ ...defaultBranding, isLoading: false });
        });

    }, [id, token]); // Re-fetch if id or token changes

    return (
        <BrandingContext.Provider value={branding}>
            {children}
        </BrandingContext.Provider>
    );
};
